import { motion } from 'framer-motion';

interface SkeletonProps {
  className?: string;
  variant?: 'text' | 'circular' | 'rectangular';
}

const Skeleton = ({ className = '', variant = 'text' }: SkeletonProps) => {
  const baseClasses = 'bg-gray-800 animate-pulse';
  const variantClasses = {
    text: 'h-4 rounded',
    circular: 'rounded-full',
    rectangular: 'rounded-lg',
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className={`${baseClasses} ${variantClasses[variant]} ${className}`}
    />
  );
};

export const TeamCardSkeleton = () => (
  <div className="bg-black/40 backdrop-blur-sm border border-gray-800 rounded-xl overflow-hidden">
    <div className="h-64 bg-gray-800 animate-pulse" />
    <div className="p-6 space-y-4">
      <Skeleton className="w-3/4" />
      <Skeleton className="w-1/2" />
      <Skeleton className="w-full" />
      <Skeleton className="w-full" />
      <div className="flex gap-3">
        <Skeleton className="w-5 h-5 rounded-full" />
        <Skeleton className="w-5 h-5 rounded-full" />
        <Skeleton className="w-5 h-5 rounded-full" />
      </div>
    </div>
  </div>
);

export default Skeleton; 